var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbGlossary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-168 -1386.999) translate(168 1386.999)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.824 34.141H2.638A1.64 1.64 0 0 0 1 35.779v7.185A1.64 1.64 0 0 0 2.638 44.6h7.186a1.64 1.64 0 0 0 1.638-1.638v-7.183a1.64 1.64 0 0 0-1.638-1.638zm1.068 8.824a1.069 1.069 0 0 1-1.068 1.068H2.638a1.069 1.069 0 0 1-1.068-1.068v-7.186a1.069 1.069 0 0 1 1.068-1.068h7.186a1.069 1.069 0 0 1 1.068 1.068v7.185z",
    transform: "translate(-168 -1386.999) translate(167.679 1385.712) translate(0 -20.584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.47 42.959a1.1 1.1 0 0 0 .775-1.137c0-.781-.527-1.393-1.86-1.393h-2.048v5.263h2.3c1.37 0 1.9-.673 1.9-1.461a1.257 1.257 0 0 0-1.067-1.272zm-2.244-1.709h1.137c.566 0 .956.147.956.708q0 .655-.964.655h-1.129V41.25zm1.393 3.622h-1.393v-1.439h1.28q1.122 0 1.122.7c0 .602-.403.738-1.009.738z",
    transform: "translate(-168 -1386.999) translate(167.679 1385.712) translate(-6.034 -24.647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.99 12.75a1.64 1.64 0 0 0 1.638-1.638V3.926a1.64 1.64 0 0 0-1.638-1.638H19.8a1.64 1.64 0 0 0-1.638 1.638v7.186A1.64 1.64 0 0 0 19.8 12.75h7.19zm-8.254-1.638V3.926A1.069 1.069 0 0 1 19.8 2.858h7.19a1.069 1.069 0 0 1 1.068 1.068v7.186a1.069 1.069 0 0 1-1.068 1.068H19.8a1.069 1.069 0 0 1-1.064-1.068z",
    transform: "translate(-168 -1386.999) translate(167.679 1385.712) translate(-11.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.532 12.642h2.635l.527 1.2h.949l-2.319-5.266h-.949l-2.319 5.263h.949zm1.318-2.989l.957 2.169h-1.913z",
    transform: "translate(-168 -1386.999) translate(167.679 1385.712) translate(-15.545 -4.063)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.252 34.141h-7.185a1.64 1.64 0 0 0-1.638 1.638v7.185a1.64 1.64 0 0 0 1.638 1.636h7.186a1.64 1.64 0 0 0 1.638-1.638v-7.183a1.64 1.64 0 0 0-1.639-1.638zm1.068 8.824a1.069 1.069 0 0 1-1.068 1.068h-7.185A1.069 1.069 0 0 1 36 42.965v-7.186a1.069 1.069 0 0 1 1.068-1.068h7.186a1.069 1.069 0 0 1 1.068 1.068v7.185z",
    transform: "translate(-168 -1386.999) translate(167.679 1385.712) translate(-22.248 -20.584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3 40.94a1.941 1.941 0 0 1 1.5.648l.565-.617a2.648 2.648 0 0 0-2.044-.9 2.7 2.7 0 0 0-2.827 2.741 2.742 2.742 0 0 0 4.8 1.785l-.572-.587a1.954 1.954 0 0 1-1.484.647 1.832 1.832 0 0 1-1.815-1.879A1.8 1.8 0 0 1 46.3 40.94z",
    transform: "translate(-168 -1386.999) translate(167.679 1385.712) translate(-27.456 -24.413)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbGlossary);
export default __webpack_public_path__ + "static/media/rb-glossary.993f98145962eacd9aa34697021e0d49.svg";
export { ForwardRef as ReactComponent };